import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03bf2419"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "course d-flex flex-column" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "text-center mt-3 pb-4 mb-2" }
const _hoisted_4 = { class: "d-flex flex-wrap wrapper mt-4" }
const _hoisted_5 = {
  key: 0,
  class: "slider-window"
}
const _hoisted_6 = ["src", "height"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 1,
  class: "row"
}
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "heading mb-2" }, "Herzlich Glückwunsch", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_banner = _resolveComponent("banner")!
  const _component_submodule_tab = _resolveComponent("submodule-tab")!
  const _component_questions_component = _resolveComponent("questions-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.course)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.isModuleCompleted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.course.name), 1),
                _createVNode(_component_banner, {
                  points: _ctx.points(),
                  image: "course-banner-img.png"
                }, null, 8, ["points"]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_submodule_tab, {
                    class: "modules-list",
                    submodules: _ctx.course.subModules,
                    activeSubModule: _ctx.activeSubModule,
                    courseName: _ctx.course.name,
                    onChangeActiveModule: _ctx.changeActiveModule
                  }, null, 8, ["submodules", "activeSubModule", "courseName", "onChangeActiveModule"]),
                  (_ctx.mobileOverlay || _ctx.isDesktop)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", {
                          class: "close-btn",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mobileOverlay = false))
                        }, "X"),
                        (!_ctx.isQuestionsVisible(_ctx.activeSubModule.recordId))
                          ? (_openBlock(), _createElementBlock("iframe", {
                              key: 0,
                              id: "iframe-pptx",
                              ref: "iframe-pptx",
                              class: "mb-5",
                              onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getIframeWidth && _ctx.getIframeWidth(...args))),
                              src: _ctx.activeSubModule['Google Spread Sheet']?.value.replace(
              '/pub?',
              '/embed?'
            )
              ,
                              frameborder: "0",
                              width: "100%",
                              height: _ctx.iframeWidth,
                              allowfullscreen: "true",
                              mozallowfullscreen: "true",
                              webkitallowfullscreen: "true"
                            }, null, 40, _hoisted_6))
                          : _createCommentVNode("", true),
                        (_ctx.isQuestionsVisible(_ctx.activeSubModule.recordId))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createVNode(_component_questions_component, {
                                activeSubModule: _ctx.activeSubModule,
                                courseName: _ctx.course.name,
                                onJumpToNextSubmodule: _ctx.jumpToNextSubmodule
                              }, null, 8, ["activeSubModule", "courseName", "onJumpToNextSubmodule"])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("p", null, [
                    _createTextVNode(" Sie haben den Themenbereich " + _toDisplayString(_ctx.course.name) + " erfolgreich bearbeitet.", 1),
                    _hoisted_11,
                    _createTextVNode(" Ihre Bescheinung können Sie sich hier herunterladen: "),
                    _createElementVNode("a", {
                      class: "cursor-pointer no-underline",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getUserPDF && _ctx.getUserPDF(...args)))
                    }, "PDF"),
                    _createTextVNode(". "),
                    _hoisted_12,
                    _hoisted_13,
                    _createTextVNode(" Bitte schauen Sie sich auch die anderen "),
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.goto('/course')), ["prevent"]))
                    }, "Themenbereiche"),
                    _createTextVNode(" an. ")
                  ])
                ])
              ]))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}